/* eslint-disable import/no-cycle */
import client from 'client';
import i18n from 'config/i18n';
import { sessionProvider } from 'utils';
import { fetchOrganization } from './organization';

import AccountActionTypes from '../types/account';
// eslint-disable-next-line arrow-body-style
export const fetchAccount = (forceFetch = false, onSuccessCb) => {
  return async (dispatch, getState) => {
    const {
      account: { data: user, loading },
    } = getState();
    if (forceFetch || (sessionProvider.isAuthenticated() && !loading && !Object.keys(user || {}).length > 0)) {
      try {
        await dispatch({
          type: AccountActionTypes.LOAD_ACCOUNT_REQUEST,
        });
        const { data } = await client.get('/apis/v2/accounts/current');
        const newLanguage = data?.data?.attributes?.language;
        await dispatch({
          type: AccountActionTypes.LOAD_ACCOUNT_SUCCESS,
          payload: { data: data?.data },
        });
        i18n.changeLanguage(newLanguage);
        await dispatch(fetchOrganization());
        if (onSuccessCb) onSuccessCb();
      } catch (error) {
        await dispatch({
          type: AccountActionTypes.LOAD_ACCOUNT_FAILURE,
          error,
        });
      }
    }
  };
};

export const clearAccount = () => async (dispatch) => {
  dispatch({
    type: AccountActionTypes.LOAD_ACCOUNT_SUCCESS,
    payload: { data: null },
  });
};
